import Swal from 'sweetalert2'
import { ApiManager } from '../../core/api-manager';

const notificationTitle = '📰 Nuova notizia disponibile';

function buildPreviewHtml(data, type) {
    const bodyText = type === 'insert'
        ? `Nuova news: ${data.title || 'scopri le ultime novità!'}`
        : `Nuovi aggiornamenti su: ${data.title || 'una notizia recente'}`;
    const actionLabel = type === 'insert' ? 'pubblicata' : 'aggiornata';

    return `
        <p style="margin:0 0 20px;color:#555;font-size:14px;">
            La notizia verrà <strong>${actionLabel}</strong> e verrà inviata una notifica push a tutti gli utenti.
        </p>
        <div style="
            background:#f2f2f7;
            border-radius:14px;
            padding:12px 14px;
            display:flex;
            align-items:flex-start;
            gap:12px;
            text-align:left;
            none-box-shadow:0 2px 8px rgba(0,0,0,0.10);
            max-width:340px;
            margin:0 auto;
            border: solid 1px rgba(0,0,0,0.10);
        ">
            <img
                src="/App Icon.png"
                alt="App Icon"
                style="width:44px;height:44px;border-radius:10px;flex-shrink:0;object-fit:cover;"
                onerror="this.style.display='none'"
            />
            <div style="flex:1;min-width:0;">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:2px;">
                    <span style="font-size:12px;font-weight:600;color:#3a3a3c;text-transform:uppercase;letter-spacing:0.3px;">mp Edile</span>
                    <span style="font-size:11px;color:#8e8e93;">adesso</span>
                </div>
                <div style="font-size:13px;font-weight:600;color:#1c1c1e;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                    ${notificationTitle}
                </div>
                <div style="font-size:13px;color:#3a3a3c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                    ${bodyText}
                </div>
            </div>
        </div>
    `;
}

export async function news_sendBroadcastNotification(data, type = 'insert', id = null) {

    const result = await Swal.fire({
        title: 'Notifica gli utenti',
        html: buildPreviewHtml(data, type),
        icon: 'warning',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: '#e74c3c',
        cancelButtonColor: 'transparent',
        denyButtonColor: 'transparent',
        confirmButtonText: 'Invia Notifica',
        cancelButtonText: 'Salva senza notifica',
        denyButtonText: '← Torna alla modifica',
        reverseButtons: true,
        allowEscapeKey: false,
        allowOutsideClick: false,

        didOpen: (modal) => {
            const cancelBtn = modal.querySelector('.swal2-cancel');
            if (cancelBtn) {
                cancelBtn.style.cssText = `
                    background: transparent !important;
                    border: 2px solid #e74c3c !important;
                    color: #e74c3c !important;
                    font-weight: 600;
                `;
            }
            const denyBtn = modal.querySelector('.swal2-deny');
            if (denyBtn) {
                denyBtn.style.cssText = `
                    background: transparent !important;
                    border: 2px solid #6c757d !important;
                    color: #6c757d !important;
                    font-weight: 600;
                `;
            }
        }
    });

    if (result.isDenied) {
        return {
            success: 0,
            data,
            message: 'Torna alla modifica'
        };
    }

    if (result.isConfirmed) {
        await ApiManager.sendAuthenticatedRequest('/custom/send_broadcast_notification', {
            title: notificationTitle,
            body: type === 'insert'
                ? `Nuova news: ${data.title || 'scopri le ultime novità!'}`
                : `Nuovi aggiornamenti su: ${data.title || 'una notizia recente'}`,
            ...(id ? { clickAction: { url: `mpedile://news/${id}` } } : {})
        });
    }

    return {
        success: 1,
        data,
        message: ''
    };
}
